import { jsx as o, jsxs as r, Fragment as c } from "react/jsx-runtime";
import { P as n, t as d, Q as i } from "../../vendor-Dd6qj6gJ.js";
import { BaseIcon as l } from "../BaseIcon/index.js";
import { c as e } from "../../styles.module-BF2N4g8-.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as p } from "../../utils/omitStyleRenderProps/index.js";
function b({ allowsResizing: a, children: m, ...s }) {
  return /* @__PURE__ */ o(n, { ...p(s), className: e.column, children: ({ allowsSorting: t }) => /* @__PURE__ */ r(c, { children: [
    /* @__PURE__ */ r(d, { role: "presentation", tabIndex: -1, className: e.columnHeader, children: [
      m,
      t && /* @__PURE__ */ o(l, { icon: "up", className: e.sortIndicator })
    ] }),
    a && /* @__PURE__ */ o(i, { className: e.columnResizer })
  ] }) });
}
b.displayName = "Table.Column";
export {
  b as Column
};
